import React, { useEffect, useRef, useState, useContext } from "react";
import ReactDOM from "react-dom";
import { NewContext } from "../utils/ContextProvider";
import { changePassword } from "../utils/peticionesApi";
import "../css/ModalSetNewPassword.css";

const pwRules = (v) => {
  const errs = [];
  if (!v || v.length < 8) errs.push("Debe tener al menos 8 caracteres.");
  if (!/[A-Z]/.test(v)) errs.push("Debe contener al menos una mayúscula.");
  if (!/[a-z]/.test(v)) errs.push("Debe contener al menos una minúscula.");
  if (!/[0-9]/.test(v)) errs.push("Debe contener al menos un número.");
  return errs;
};

export default function ModalCambiarPassword({ show, onClose }) {
  const { getAlert } = useContext(NewContext);
  const [password, setPassword] = useState("");
  const [repeat, setRepeat] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPw, setShowPw] = useState(false);
  const [showPw2, setShowPw2] = useState(false);
  const [errors, setErrors] = useState([]);
  const [errorField, setErrorField] = useState("");
  const inputRef = useRef(null);

  useEffect(() => {
    if (show) {
      setTimeout(() => inputRef.current?.focus(), 50);
    } else {
      setPassword("");
      setRepeat("");
      setErrors([]);
      setErrorField("");
      setLoading(false);
      setShowPw(false);
      setShowPw2(false);
    }
  }, [show]);

  useEffect(() => {
    if (!show) return;
    const handler = (e) => {
      if (e.key === "Escape" && !loading) onClose?.();
    };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [show, loading, onClose]);

  if (!show) return null;

  const validate = () => {
    const errs = pwRules(password);
    if (password !== repeat) errs.push("Las contraseñas no coinciden.");
    setErrors(errs);
    return errs.length === 0;
  };

  const handleSubmit = async () => {
    if (loading) return;
    if (!validate()) return;

    setLoading(true);
    setErrorField("");
    try {
      await changePassword(password);
      getAlert?.({ msj: "Contraseña actualizada correctamente", tipe: "succes" });
      onClose?.();
    } catch (e) {
      const msg =
        e.response?.data?.message ||
        e.response?.data?.error ||
        (typeof e.response?.data === "string" && e.response.data) ||
        "No se pudo actualizar la contraseña.";
      setErrorField(msg);
      getAlert?.({ msj: msg, tipe: "error" });
    } finally {
      setLoading(false);
    }
  };

  return ReactDOM.createPortal(
    <div className="modal-overlay-reset" aria-modal="true" role="dialog">
      <div className="modal-reset" onClick={(e) => e.stopPropagation()}>
        <div className="modal-reset-header">
          <h3>Cambiar contraseña</h3>
          <button
            className="reset-close-btn"
            type="button"
            onClick={() => !loading && onClose?.()}
            aria-label="Cerrar"
          >
            ×
          </button>
        </div>

        <div className="modal-reset-body" role="form">
          <p className="reset-help">
            Ingresá tu nueva contraseña. Debe tener al menos 8 caracteres, una
            mayúscula, una minúscula y un número.
          </p>

          <div className="reset-row">
            <label htmlFor="cpNewPassword">Nueva contraseña</label>
            <div className="reset-field-wrap">
              <input
                id="cpNewPassword"
                ref={inputRef}
                type={showPw ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Ingresá tu nueva contraseña"
                autoComplete="new-password"
                disabled={loading}
                className="reset-input"
              />
              <button
                type="button"
                aria-label={showPw ? "Ocultar contraseña" : "Mostrar contraseña"}
                onClick={() => setShowPw((s) => !s)}
                disabled={loading}
                className="reset-toggle-btn"
              >
                {showPw ? "Ocultar" : "Ver"}
              </button>
            </div>
          </div>

          <div className="reset-row">
            <label htmlFor="cpRepeatPassword">Confirmar contraseña</label>
            <div className="reset-field-wrap">
              <input
                id="cpRepeatPassword"
                type={showPw2 ? "text" : "password"}
                value={repeat}
                onChange={(e) => setRepeat(e.target.value)}
                placeholder="Repetí la nueva contraseña"
                autoComplete="new-password"
                disabled={loading}
                className="reset-input"
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    handleSubmit();
                  }
                }}
              />
              <button
                type="button"
                aria-label={showPw2 ? "Ocultar contraseña" : "Mostrar contraseña"}
                onClick={() => setShowPw2((s) => !s)}
                disabled={loading}
                className="reset-toggle-btn"
              >
                {showPw2 ? "Ocultar" : "Ver"}
              </button>
            </div>
          </div>

          {(errors.length > 0 || errorField) && (
            <div className="reset-error">
              {errorField || (
                <ul>
                  {errors.map((e, i) => (
                    <li key={i}>{e}</li>
                  ))}
                </ul>
              )}
            </div>
          )}

          <div className="modal-reset-footer">
            <button
              className="reset-btn-primary"
              type="button"
              disabled={loading}
              onClick={handleSubmit}
            >
              {loading ? "Guardando..." : "Cambiar contraseña"}
            </button>
            <button
              className="reset-btn-cancel"
              type="button"
              onClick={() => !loading && onClose?.()}
              disabled={loading}
            >
              Cancelar
            </button>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
}
